(function(){
  if (window.__fuSizeFinder) return;
  window.__fuSizeFinder = true;

  /* ---------- SIZE SETTINGS PER PRODUCT ----------
     Every product sizes off one "body score" (cm) worked out from height,
     weight and the frame answers. bounds = where each size ends on that score.
     Calibrated against the model stats on each product page:
       174cm 73kg  -> S in Compression Tee, Tank, Mesh Shorts; M in Conquer 4" Shorts
       181cm 87kg  -> M in the Long Sleeve
       185cm 85kg  -> M in the Four You tee (oversized)
       187cm 93kg  -> XL in the Tee, Tank and Mesh Shorts
     runsSmall products have their bounds shifted one size down, so the
     finder sizes people up automatically (Conquer 4" Shorts).
     To add a product: copy an entry, set its handle, sizes and bounds, and add
     the handle to fu_sf_handles in layout/theme.liquid. */
  var COMP_PREFS = [
    { t: 'Locked in', d: 'Maximum hold. Second skin, every rep on show.', w: .82 },
    { t: 'Athletic', d: 'The fit we engineered it for. Firm, never restrictive.', tag: 'Our cut', w: 1 },
    { t: 'Relaxed', d: 'Lighter hold with room to move and layer.', w: 1.16 }
  ];
  var CONFIG = {
    'conquer-compression-long-sleeve': {
      type: 'top', compression: true, sizes: ['XS', 'S', 'M', 'L', 'XL'], bounds: [88, 95, 103, 107.5],
      rows: ['Chest', 'Waist', 'Length', 'Sleeve'], prefAdj: [-4, 0, 4], prefs: COMP_PREFS,
      model: 'Our model: 181cm, 87kg, wears M.'
    },
    'conquer-compression-tee': {
      type: 'top', compression: true, sizes: ['S', 'M', 'L', 'XL'], bounds: [95, 103, 107.5],
      rows: ['Chest', 'Waist', 'Length', 'Arms'], prefAdj: [-4, 0, 4], prefs: COMP_PREFS,
      model: 'Our models: 174cm, 73kg wears S. 187cm, 93kg wears XL.'
    },
    'essentials-tank': {
      type: 'top', sizes: ['S', 'M', 'L', 'XL'], bounds: [95, 103, 107.5],
      rows: ['Chest', 'Waist', 'Length'], prefAdj: [-3, 0, 4],
      lead2: 'Your frame decides the fit, not just the scale. Unsure? Stay on average.',
      step3: 'How do you like it to sit?', lead3: 'Deep chest, tapered waist. Pick how close you want it.',
      prefs: [
        { t: 'Fitted', d: 'Closer through the chest and waist. Shows the taper.', w: .86 },
        { t: 'Classic', d: 'Relaxed chest, tapered waist. How we cut it.', tag: 'Our cut', w: 1 },
        { t: 'Loose', d: 'Extra room for an easy, laid-back drape.', w: 1.14 }
      ],
      model: 'Our models: 174cm, 73kg wears S. 187cm, 93kg wears XL.'
    },
    'four-you-t-shirt': {
      type: 'top', sizes: ['XS', 'S', 'M', 'L', 'XL'], bounds: [88, 95, 103, 110],
      rows: ['Chest', 'Shoulders', 'Length'], prefAdj: [-5, 0, 5],
      lead2: 'Your frame decides the fit, not just the scale. Unsure? Stay on average.',
      step3: 'How do you like it to sit?', lead3: 'Cut oversized with drop shoulders. Pick your drape.',
      prefs: [
        { t: 'Less oversized', d: 'A cleaner, closer drape. We size you down.', w: .9 },
        { t: 'Oversized', d: 'Drop shoulders, boxy body. How it is designed.', tag: 'Our cut', w: 1.1 },
        { t: 'Extra boxy', d: 'Maximum drape and length. We size you up.', w: 1.28 }
      ],
      model: 'Our model: 185cm, 85kg, wears M.'
    },
    'core-4-mesh-shorts': {
      type: 'bottom', sizes: ['S', 'M', 'L', 'XL'], bounds: [94.5, 99, 103.5],
      rows: ['Waist', 'Hips', 'Thighs', 'Length'], prefAdj: [-3, 0, 3],
      prefs: [
        { t: 'Fitted', d: 'Closer through the waist and thigh.', w: .9 },
        { t: 'Athletic', d: 'Relaxed athletic fit with room to move. True to size.', tag: 'Our cut', w: 1 },
        { t: 'Relaxed', d: 'Extra room through the leg.', w: 1.12 }
      ],
      model: 'Our models: 174cm, 73kg wears S. 187cm, 93kg wears XL.'
    },
    'conquer-mens-activewear-shorts': {
      type: 'bottom', runsSmall: true, sizes: ['S', 'M', 'L', 'XL'], bounds: [90.5, 95, 99.5],
      rows: ['Waist', 'Hips', 'Thighs', 'Length'], prefAdj: [-3, 0, 3],
      prefs: [
        { t: 'Fitted', d: 'Locked in through the hip and thigh.', w: .9 },
        { t: 'Athletic', d: 'Not baggy, not restrictive. How we cut it.', tag: 'Our cut', w: 1 },
        { t: 'Relaxed', d: 'Extra room through the leg for big quads.', w: 1.12 }
      ],
      model: 'Our model: 174cm, 73kg wears M here (S in our Mesh Shorts).'
    }
  };
  /* height (cm) each size is cut for, used for length and sleeve rows */
  var SIZE_H = { XS: 168, S: 174, M: 180, L: 186, XL: 192 };

  var dataEl = document.getElementById('FuSizeFinderData');
  if (!dataEl) return;
  var P;
  try { P = JSON.parse(dataEl.textContent); } catch (e) { return; }
  var C = CONFIG[P.handle];
  if (!C) return;

  var STORE = 'fu-fit-profile';
  var sizeIdx = -1, colorIdx = -1;
  (P.options || []).forEach(function(n, i){
    var l = String(n).toLowerCase();
    if (l.indexOf('size') > -1) sizeIdx = i;
    if (l.indexOf('colo') > -1) colorIdx = i;
  });
  if (sizeIdx < 0) return;

  /* ---------- state ---------- */
  var BOTTOM = C.type === 'bottom';
  var DK = BOTTOM ? 'dBot' : 'dTop';   /* tops and shorts are answered separately */
  var S = { h: 180, w: 80, hu: 'cm', wu: 'kg', chest: 0, stomach: 0, arms: 0, thighs: 0, glutes: 0, pref: 1, dTop: false, dBot: false };
  function load(){
    try {
      var s = JSON.parse(localStorage.getItem(STORE) || 'null');
      if (s && typeof s.h === 'number' && typeof s.w === 'number') {
        for (var k in S) if (s[k] !== undefined) S[k] = s[k];
        if (s.done && s.dTop === undefined) S.dTop = true;
      }
    } catch (e) {}
  }
  function save(){
    try { localStorage.setItem(STORE, JSON.stringify(S)); } catch (e) {}
  }
  load();

  /* ---------- sizing maths ---------- */
  /* Frame answers in cm of body score. Lean / flat pulls the size down; big arms
     only tighten the arm and sleeve rows (they never push a top up a size). */
  var ADJ = BOTTOM
    ? { stomach: [-2, 0, 4], thighs: [-1.5, 0, 2.5], glutes: [-1, 0, 1.5] }
    : { chest: [-5, 0, 3], stomach: [-2.5, 0, 4], arms: [0, 0, 0] };
  var PREF = C.prefAdj || [-5, 0, 4];
  var bounds = C.bounds, N = C.sizes.length;
  var centres = [], halves = [];
  for (var i = 0; i < N; i++) {
    var lo = i === 0 ? bounds[0] - 7 : bounds[i - 1];
    var hi = i === N - 1 ? bounds[N - 2] + 7 : bounds[i];
    centres.push((lo + hi) / 2);
    halves.push((hi - lo) / 2);
  }
  function a(key, s){ return ADJ[key] ? ADJ[key][s[key] + 1] : 0; }
  function bodyScore(s){
    var base = 67 + 0.6 * s.w - 0.1 * s.h;
    /* tops: taller bodies need more length, so height pulls the size up */
    return BOTTOM ? base + a('stomach', s) + a('thighs', s) + a('glutes', s)
                  : base + 0.5 * (s.h - 180) + a('chest', s) + a('stomach', s) + a('arms', s);
  }
  function hFor(j){ return SIZE_H[C.sizes[j]] || 180; }
  function calc(s, withPref){
    var eff = bodyScore(s) + (withPref ? PREF[s.pref] : 0);
    var idx = 0;
    while (idx < bounds.length && eff >= bounds[idx]) idx++;
    var d = Math.abs(eff - centres[idx]);
    var pct = Math.round(97 - (d / halves[idx]) * 12);
    pct = Math.max(64, Math.min(97, pct));
    var hIdx = 0, best = 1e9;
    for (var j = 0; j < N; j++) { var dd = Math.abs(hFor(j) - s.h); if (dd < best) { best = dd; hIdx = j; } }
    return { eff: eff, idx: idx, pct: pct, d: d, rel: (eff - centres[idx]) / halves[idx], hIdx: hIdx };
  }
  var ARM = [-0.15, 0, 0.45];
  function fitsFor(s, r, j){
    var room = centres[j] - r.eff;
    var out = [];
    C.rows.forEach(function(name){
      var v = 0;
      if (name === 'Chest' || name === 'Shoulders') v = room / 8;
      else if (name === 'Waist') v = BOTTOM ? (room - a('stomach', s)) / 6 : (room - a('stomach', s) * 1.3) / 8;
      else if (name === 'Length') v = (hFor(j) - s.h) / (BOTTOM ? 16 : 11);
      else if (name === 'Sleeve') v = (hFor(j) - s.h) / 11 - ARM[s.arms + 1] * 0.5;
      else if (name === 'Arms') v = room / 8 - ARM[s.arms + 1];
      else if (name === 'Hips') v = (room - a('glutes', s)) / 6;
      else if (name === 'Thighs') v = (room - a('thighs', s) * 1.2) / 6;
      out.push([name, v]);
    });
    return out;
  }
  function word(v){
    if (v < -0.7) return 'Tight';
    if (v < -0.25) return 'Snug';
    if (v <= 0.25) return 'Spot on';
    if (v <= 0.7) return 'Roomy';
    return 'Loose';
  }

  /* ---------- units ---------- */
  function fmtH(cm){
    if (S.hu === 'cm') return { n: String(Math.round(cm)), u: 'cm' };
    var inch = Math.round(cm / 2.54);
    return { n: Math.floor(inch / 12) + '′' + (inch % 12) + '″', u: '' };
  }
  function fmtW(kg){
    if (S.wu === 'kg') return { n: String(Math.round(kg)), u: 'kg' };
    return { n: String(Math.round(kg * 2.20462)), u: 'lbs' };
  }

  /* ---------- page helpers ---------- */
  function mainPicker(){
    var all = document.querySelectorAll('variant-selects');
    for (var i = 0; i < all.length; i++) {
      if (!all[i].closest('quick-view, .quick-view, x-modal, .fu-sf')) return all[i];
    }
    return null;
  }
  function sizeFieldset(){
    var vs = mainPicker();
    if (!vs) return null;
    return vs.querySelector('fieldset[data-option-index="option' + (sizeIdx + 1) + '"]') || vs.querySelector('fieldset[data-option-slug="size"]');
  }
  function currentColor(){
    if (colorIdx < 0) return null;
    var vs = mainPicker();
    var el = vs && vs.querySelector('fieldset[data-option-index="option' + (colorIdx + 1) + '"] input:checked');
    return el ? el.value : null;
  }
  function variantFor(size){
    var col = currentColor();
    for (var i = 0; i < P.variants.length; i++) {
      var v = P.variants[i];
      if (v.options[sizeIdx] === size && (col === null || colorIdx < 0 || v.options[colorIdx] === col)) return v;
    }
    return null;
  }
  function selectSize(size){
    var fs = sizeFieldset();
    if (!fs) return false;
    var inputs = fs.querySelectorAll('input[type="radio"]');
    for (var i = 0; i < inputs.length; i++) {
      if (inputs[i].value === size) {
        if (!inputs[i].checked) inputs[i].click();
        return true;
      }
    }
    return false;
  }
  /* Bundle offer pages (Tank, Mesh Shorts) hide the normal size buttons and use
     the "Buy 2, Get 1 Free" picker (.fuo) with a size row per item instead. */
  function offerEl(){
    var o = document.querySelector('.fuo');
    return o && o.offsetParent ? o : null;
  }
  function offerMode(){
    var fs = sizeFieldset();
    return !!offerEl() && !(fs && fs.offsetParent);
  }
  function setOfferSize(size, onlyEmpty){
    var o = offerEl();
    if (!o) return 0;
    var n = 0;
    o.querySelectorAll('.fuo-slot').forEach(function(slot){
      if (!slot.offsetParent) return;
      if (onlyEmpty && slot.querySelector('.fuo-sz[aria-pressed="true"]')) return;
      var b = slot.querySelector('.fuo-sz[data-s="' + size + '"]');
      if (b && !b.disabled) { if (b.getAttribute('aria-pressed') !== 'true') b.click(); n++; }
    });
    return n;
  }
  function addButton(){
    var btns = document.querySelectorAll('.product-form__submit[name="add"], button[name="add"][type="submit"]');
    for (var i = 0; i < btns.length; i++) {
      if (!btns[i].closest('quick-view, .quick-view, .fu-sf, x-modal')) return btns[i];
    }
    return null;
  }
  function addToCart(variant){
    var btn = addButton();
    var form = btn && btn.form;
    var start = Date.now();
    (function wait(){
      var idInput = form && form.querySelector('[name="id"]');
      var ready = idInput && String(idInput.value) === String(variant.id) && !btn.disabled;
      if (ready || Date.now() - start > 2500) {
        if (ready) btn.click();
        else { /* theme did not update in time: add directly */
          fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart/add.js', {
            method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ items: [{ id: variant.id, quantity: 1 }] })
          }).then(function(){ document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true })); window.location.href = (window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart'; });
        }
        return;
      }
      setTimeout(wait, 60);
    })();
  }
  function track(name, payload){
    try { if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish(name, payload || {}); } catch (e) {}
  }

  /* ---------- icons ---------- */
  var IC = {
    close: '<svg viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"><path d="M3 3l10 10M13 3L3 13"/></svg>',
    arrow: '<svg viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M2.5 8h11M9 3.5 13.5 8 9 12.5"/></svg>',
    back: '<svg viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M13.5 8h-11M7 3.5 2.5 8 7 12.5"/></svg>',
    redo: '<svg viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M2.5 8a5.5 5.5 0 1 0 1.7-4"/><path d="M2.5 2.5v3h3"/></svg>',
    lock: '<svg viewBox="0 0 12 12" fill="none" stroke="currentColor" stroke-width="1.2"><rect x="2" y="5.2" width="8" height="5.8" rx="1.2"/><path d="M4 5.2V3.8a2 2 0 0 1 4 0v1.4"/></svg>',
    tape: '<svg viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"><path d="M12.5 13.5v-3m-3 3v-3m-3 3v-3M4 6.5c1.933 0 3.5-.895 3.5-2s-1.567-2-3.5-2-3.5.895-3.5 2 1.567 2 3.5 2Z"/><path d="M.5 11.5c0 1.105 1.567 2 3.5 2h11.5v-7H4c-1.933 0-3.5-.895-3.5-2v7Z"/></svg>',
    body: '<svg viewBox="0 0 60 156" fill="currentColor" aria-hidden="true"><circle cx="30" cy="11" r="8"/><path d="M27 19h6v4c5 0 11 1 13 4l3 19 2 24-1 14h-3l-1-14-3-22-1 14-1 16 1 22-1 24-1 28h-6l-1-28-1-24-2-14-2 14-1 24-1 28h-6l-1-28-1-24 1-22-1-16-1-14-3 22-1 14h-3l-1-14 2-24 3-19c2-3 8-4 13-4z"/></svg>',
    chest: [
      '<svg viewBox="0 0 28 28" fill="none" stroke="currentColor" stroke-width="1.3" stroke-linejoin="round"><path d="M10.5 5h7l-1 18h-5z"/></svg>',
      '<svg viewBox="0 0 28 28" fill="none" stroke="currentColor" stroke-width="1.3" stroke-linejoin="round"><path d="M8 5h12l-2 18h-8z"/></svg>',
      '<svg viewBox="0 0 28 28" fill="none" stroke="currentColor" stroke-width="1.3" stroke-linejoin="round"><path d="M4.5 5h19l-4.5 18h-10z"/></svg>'
    ],
    stomach: [
      '<svg viewBox="0 0 28 28" fill="none" stroke="currentColor" stroke-width="1.3" stroke-linecap="round"><path d="M10 4v20M18 4v20"/></svg>',
      '<svg viewBox="0 0 28 28" fill="none" stroke="currentColor" stroke-width="1.3" stroke-linecap="round"><path d="M10 4v20M18 4c2.4 4.5 2.4 15.5 0 20"/></svg>',
      '<svg viewBox="0 0 28 28" fill="none" stroke="currentColor" stroke-width="1.3" stroke-linecap="round"><path d="M10 4v20M17 4c6 4 6 16 0 20"/></svg>'
    ],
    arms: [
      '<svg viewBox="0 0 28 28" fill="none" stroke="currentColor" stroke-width="1.3" stroke-linecap="round"><path d="M12 4c0 7 0 13 1 20M16 4c0 7 0 13-1 20"/></svg>',
      '<svg viewBox="0 0 28 28" fill="none" stroke="currentColor" stroke-width="1.3" stroke-linecap="round"><path d="M11 4c-1.5 6-1.5 13 1 20M17 4c1.5 6 1.5 13-1 20"/></svg>',
      '<svg viewBox="0 0 28 28" fill="none" stroke="currentColor" stroke-width="1.3" stroke-linecap="round"><path d="M11 4c-5 5-4 13 1 20M17 4c5 5 4 13-1 20"/></svg>'
    ],
    shorts: function(sx){
      return '<svg viewBox="0 0 34 34" fill="currentColor" aria-hidden="true"><g transform="translate(17 0) scale(' + sx + ' 1) translate(-17 0)"><path d="M8 6h18l2.5 21h-8.5L17 15l-3 12H5.5z"/></g></svg>';
    },
    shirt: function(sx){
      return '<svg viewBox="0 0 34 34" fill="currentColor" aria-hidden="true"><g transform="translate(17 0) scale(' + sx + ' 1) translate(-17 0)"><path d="M13 4h8l7 4.5 3 18.5h-3.5l-3-13.5-.5 15.5H10l-.5-15.5-3 13.5H3l3-18.5z"/></g></svg>';
    }
  };

  /* ---------- build drawer ---------- */
  var root = document.createElement('div');
  root.className = 'fu-sf';
  root.hidden = true;
  /* Open in the browser's top layer so nothing on the page (or Shopify's
     preview bar) can sit on top of the drawer and block its buttons. */
  var canTop = typeof root.showPopover === 'function';
  if (canTop) root.setAttribute('popover', 'manual');
  var shape = BOTTOM ? [
    { key: 'stomach', icon: 'stomach', label: 'Waist', opts: ['Flat', 'Average', 'Fuller'] },
    { key: 'thighs', icon: 'arms', label: 'Thighs', opts: ['Lean', 'Average', 'Built'] },
    { key: 'glutes', icon: 'stomach', label: 'Glutes', opts: ['Flat', 'Average', 'Built'] }
  ] : [
    { key: 'chest', icon: 'chest', label: 'Chest', opts: ['Lean', 'Average', 'Broad'] },
    { key: 'stomach', icon: 'stomach', label: 'Stomach', opts: ['Flat', 'Average', 'Fuller'] },
    { key: 'arms', icon: 'arms', label: 'Arms', opts: ['Lean', 'Average', 'Built'] }
  ];
  root.innerHTML = ''
    + '<div class="fu-sf__overlay" data-close></div>'
    + '<div class="fu-sf__panel" role="dialog" aria-modal="true" aria-label="Find your fit" tabindex="-1">'
    +   '<div class="fu-sf__grab" aria-hidden="true"></div>'
    +   '<div class="fu-sf__head"><span class="fu-sf__eyebrow">Find your fit</span><button type="button" class="fu-sf__close" data-close aria-label="Close">' + IC.close + '</button></div>'
    +   '<div class="fu-sf__body">'
    +     '<div class="fu-sf__product"><img alt="" data-img><div><div class="fu-sf__product-name">' + escapeHtml(P.title) + '</div><div class="fu-sf__product-price" data-price></div></div></div>'
    +     '<div class="fu-sf__progress" aria-hidden="true"><span></span><span></span><span></span></div>'
    +     '<div class="fu-sf__count" data-count>Step 1 of 3</div>'
    +     '<div class="fu-sf__steps">'
    /* step 1 */
    +       '<section class="fu-sf__step" data-step="0">'
    +         '<h2 class="fu-sf__title">Your build</h2>'
    +         '<p class="fu-sf__lead">Height and weight. Drag the sliders to set yours.</p>'
    +         '<div class="fu-sf__measure">'
    +           '<div class="fu-sf__figure"><span class="fu-sf__figwrap" data-fig><span class="fu-sf__figline" data-figline></span>' + IC.body + '</span></div>'
    +           '<div class="fu-sf__controls">'
    +             dialHtml('h', 'Height', [['cm', 'cm'], ['ft', 'ft/in']])
    +             dialHtml('w', 'Weight', [['kg', 'kg'], ['lbs', 'lbs']])
    +           '</div>'
    +         '</div>'
    +         '<div class="fu-sf__estimate"><div><div class="fu-sf__label">Current read</div><div class="fu-sf__estimate-sub">Locks in after two more steps</div></div><div class="fu-sf__estimate-size" data-estimate aria-live="polite"></div></div>'
    +         '<div class="fu-sf__private">' + IC.lock + '<span>Stored on this device only. Your size follows you across 4U.</span></div>'
    +       '</section>'
    /* step 2 */
    +       '<section class="fu-sf__step" data-step="1" hidden>'
    +         '<h2 class="fu-sf__title">Your frame</h2>'
    +         '<p class="fu-sf__lead">' + (C.lead2 || (BOTTOM ? 'Shorts fit your waist, quads and glutes. Unsure? Stay on average.' : 'Compression fits the body, not the label. Unsure? Stay on average.')) + '</p>'
    +         shape.map(function(g){
                return '<div class="fu-sf__group"><div class="fu-sf__label">' + g.label + '</div><div class="fu-sf__choices" role="radiogroup" aria-label="' + g.label + '">'
                  + g.opts.map(function(o, j){ return '<button type="button" class="fu-sf__choice" role="radio" data-shape="' + g.key + '" data-val="' + (j - 1) + '">' + IC[g.icon][j] + '<span>' + o + '</span></button>'; }).join('')
                  + '</div></div>';
              }).join('')
    +       '</section>'
    /* step 3 */
    +       '<section class="fu-sf__step" data-step="2" hidden>'
    +         '<h2 class="fu-sf__title">' + (C.step3 || 'How do you train in it?') + '</h2>'
    +         '<p class="fu-sf__lead">' + (C.lead3 || 'Pick the feel you want under load.') + '</p>'
    +         '<div class="fu-sf__prefs" role="radiogroup" aria-label="Fit preference">'
    +           C.prefs.map(function(p, j){
                  return '<button type="button" class="fu-sf__pref" role="radio" data-pref="' + j + '">' + (BOTTOM ? IC.shorts(p.w) : IC.shirt(p.w))
                    + '<span><span class="fu-sf__pref-t">' + p.t + (p.tag ? '<span class="fu-sf__pref-tag">' + p.tag + '</span>' : '') + '</span><span class="fu-sf__pref-d" style="display:block">' + p.d + '</span></span></button>';
                }).join('')
    +         '</div>'
    +       '</section>'
    /* result */
    +       '<section class="fu-sf__step fu-sf__result" data-step="3" hidden>'
    +         '<div class="fu-sf__hero">'
    +           '<div class="fu-sf__label">Your 4U size</div>'
    +           '<div class="fu-sf__ring"><svg viewBox="0 0 120 120"><circle class="bg" cx="60" cy="60" r="57"/><circle class="fg" cx="60" cy="60" r="57" data-ring/></svg><div class="fu-sf__ring-size" data-best></div></div>'
    +           '<div class="fu-sf__match" data-match></div>'
    +           '<p class="fu-sf__match-sub" data-matchsub></p>'
    +         '</div>'
    +         '<div class="fu-sf__recap"><span data-recap></span><button type="button" class="fu-sf__redo" data-redo>' + IC.redo + 'Redo my fit</button></div>'
    +         '<div class="fu-sf__sizes" data-sizes><span class="fu-sf__you" data-you>Yours</span>'
    +           C.sizes.map(function(sz, j){ return '<button type="button" class="fu-sf__size" data-size="' + j + '">' + sz + '</button>'; }).join('')
    +         '</div>'
    +         '<div class="fu-sf__hint">Tap any size to compare the fit.</div>'
    +         '<div class="fu-sf__fits"><div class="fu-sf__fits-head"><span></span><div class="fu-sf__fits-scale"><span>Tighter</span><span>Spot on</span><span>Looser</span></div><span></span></div><div data-fits></div></div>'
    +         '<div class="fu-sf__note"><div class="fu-sf__label">The call</div><p data-note></p></div>'
    +         (C.model ? '<div class="fu-sf__model">' + C.model + '</div>' : '')
    +       '</section>'
    +     '</div>'
    +   '</div>'
    +   '<div class="fu-sf__foot">'
    +     '<div class="fu-sf__foot-row"><button type="button" class="fu-sf__back" data-back aria-label="Back" hidden>' + IC.back + '</button><button type="button" class="fu-sf__cta" data-next></button></div>'
    +     '<button type="button" class="fu-sf__alt" data-select hidden></button>'
    +   '</div>'
    + '</div>';

  function dialHtml(k, label, units){
    return '<div class="fu-sf__row" data-row="' + k + '">'
      + '<div class="fu-sf__row-head"><span class="fu-sf__label">' + label + '</span><span class="fu-sf__units">'
      + units.map(function(u){ return '<button type="button" data-unit="' + k + '" data-u="' + u[0] + '">' + u[1] + '</button>'; }).join('')
      + '</span></div>'
      + '<div class="fu-sf__value"><span class="fu-sf__num" data-num="' + k + '"></span><span class="fu-sf__unit" data-u-label="' + k + '"></span></div>'
      + '<div class="fu-sf__dialwrap"><button type="button" class="fu-sf__step-btn" data-inc="' + k + '" data-dir="-1" aria-label="Decrease ' + label.toLowerCase() + '">−</button>'
      + '<div class="fu-sf__dial" data-dial="' + k + '" role="slider" tabindex="0" aria-label="' + label + '"><span class="fu-sf__dial-track"></span><span class="fu-sf__dial-fill"></span><span class="fu-sf__dial-ticks"></span><span class="fu-sf__dial-knob"></span></div>'
      + '<button type="button" class="fu-sf__step-btn" data-inc="' + k + '" data-dir="1" aria-label="Increase ' + label.toLowerCase() + '">+</button></div>'
      + '</div>';
  }
  function escapeHtml(s){ return String(s).replace(/[&<>"]/g, function(c){ return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }

  var $ = function(sel){ return root.querySelector(sel); };
  var $$ = function(sel){ return Array.prototype.slice.call(root.querySelectorAll(sel)); };
  var RANGE = { h: [150, 210], w: [45, 150] };
  var step = 0, viewIdx = 0, lastEstimate = null, lastBest = null, opener = null;

  /* ---------- render ---------- */
  function renderProduct(){
    var v = variantFor(C.sizes[viewIdx]) || P.variants[0];
    var img = (v && v.image) || P.image;
    var im = $('[data-img]');
    if (img && im.getAttribute('src') !== img) im.src = img;
    $('[data-price]').textContent = (v && v.price) || '';
  }
  function renderDial(k){
    var r = RANGE[k], val = S[k];
    var pct = (val - r[0]) / (r[1] - r[0]) * 100;
    var dial = $('[data-dial="' + k + '"]');
    dial.querySelector('.fu-sf__dial-knob').style.left = pct + '%';
    dial.querySelector('.fu-sf__dial-fill').style.width = pct + '%';
    var f = k === 'h' ? fmtH(val) : fmtW(val);
    var num = $('[data-num="' + k + '"]');
    if (num.textContent !== f.n) {
      num.textContent = f.n;
      num.classList.add('is-tick');
      clearTimeout(num.__t);
      num.__t = setTimeout(function(){ num.classList.remove('is-tick'); }, 120);
    }
    $('[data-u-label="' + k + '"]').textContent = f.u;
    dial.setAttribute('aria-valuemin', r[0]);
    dial.setAttribute('aria-valuemax', r[1]);
    dial.setAttribute('aria-valuenow', Math.round(val));
    dial.setAttribute('aria-valuetext', f.n + (f.u ? ' ' + f.u : ''));
    $$('[data-unit="' + k + '"]').forEach(function(b){ b.classList.toggle('is-on', b.getAttribute('data-u') === (k === 'h' ? S.hu : S.wu)); });
  }
  function renderFigure(){
    var sy = 0.84 + (S.h - 150) / 60 * 0.26;
    var bmi = S.w / Math.pow(S.h / 100, 2);
    var sx = Math.max(0.8, Math.min(1.5, 0.55 + bmi * 0.019));
    var svg = $('[data-fig] svg');
    svg.style.transform = 'scale(' + sx.toFixed(3) + ',' + sy.toFixed(3) + ')';
    /* dashed line sits on top of the head: head top is ~2% from the top of the drawing */
    $('[data-figline]').style.bottom = (sy * 98).toFixed(2) + '%';
  }
  function renderEstimate(){
    var r = calc(S, true);
    var sz = C.sizes[r.idx];
    var el = $('[data-estimate]');
    if (sz !== lastEstimate) {
      lastEstimate = sz;
      el.innerHTML = '<span class="fu-sf__swap">' + sz + '</span>';
    }
  }
  function renderShape(){
    $$('[data-shape]').forEach(function(b){
      var on = String(S[b.getAttribute('data-shape')]) === b.getAttribute('data-val');
      b.classList.toggle('is-on', on);
      b.setAttribute('aria-checked', on ? 'true' : 'false');
    });
    $$('[data-pref]').forEach(function(b){
      var on = String(S.pref) === b.getAttribute('data-pref');
      b.classList.toggle('is-on', on);
      b.setAttribute('aria-checked', on ? 'true' : 'false');
    });
  }
  function renderResult(animate){
    var r = calc(S, true);
    var best = r.idx;
    var view = viewIdx;
    var sz = C.sizes[view];
    var bestEl = $('[data-best]');
    if (bestEl.getAttribute('data-v') !== sz) {
      bestEl.setAttribute('data-v', sz);
      bestEl.innerHTML = '<span class="fu-sf__swap">' + sz + '</span>';
    }
    /* match % for the size being viewed */
    var pct = r.pct;
    if (view !== best) {
      var gap = Math.abs(view - best);
      var dir = view > best ? 1 : -1;
      pct = Math.round(r.pct - gap * 16 + (dir * r.rel > 0 ? 7 : -2));
      pct = Math.max(38, Math.min(r.pct - 3, pct));
    }
    var ring = $('[data-ring]');
    var circ = 2 * Math.PI * 57;
    ring.style.strokeDasharray = circ.toFixed(1);
    if (animate) {
      ring.style.transition = 'none';
      ring.style.strokeDashoffset = circ.toFixed(1);
      ring.getBoundingClientRect();
      ring.style.transition = '';
    }
    requestAnimationFrame(function(){ ring.style.strokeDashoffset = (circ * (1 - pct / 100)).toFixed(1); });
    countTo($('[data-match]'), pct, animate);
    var sub;
    if (view === best) sub = pct >= 90 ? 'Locked in for your build.' : pct >= 80 ? 'Strong match. Read the call below.' : 'Our closest fit for your build.';
    else sub = view < best ? 'Tighter than your match.' : 'Looser than your match.';
    $('[data-matchsub]').textContent = sub;

    /* size strip */
    $$('[data-size]').forEach(function(b){
      var j = +b.getAttribute('data-size');
      b.classList.toggle('is-view', j === view);
      var v = variantFor(C.sizes[j]);
      b.classList.toggle('is-out', !!(v && !v.available));
      b.setAttribute('aria-pressed', j === view ? 'true' : 'false');
    });
    var bBtn = $('[data-size="' + best + '"]');
    var strip = $('[data-sizes]');
    if (bBtn) $('[data-you]').style.left = (bBtn.offsetLeft + bBtn.offsetWidth / 2) + 'px';

    /* fit rows */
    var rows = fitsFor(S, r, view);
    var box = $('[data-fits]');
    if (!box.children.length) {
      box.innerHTML = rows.map(function(row){
        return '<div class="fu-sf__fit"><span class="fu-sf__fit-name">' + row[0] + '</span><span class="fu-sf__fit-track"><span class="fu-sf__fit-dot" style="left:50%"></span></span><span class="fu-sf__fit-word"></span></div>';
      }).join('');
    }
    rows.forEach(function(row, i){
      var el = box.children[i];
      var v = Math.max(-1, Math.min(1, row[1]));
      var left = 50 + v * 46;
      if (animate) el.querySelector('.fu-sf__fit-dot').style.left = '50%';
      setTimeout(function(){ el.querySelector('.fu-sf__fit-dot').style.left = left + '%'; }, animate ? 250 + i * 70 : 0);
      el.querySelector('.fu-sf__fit-word').textContent = word(row[1]);
    });

    /* fit note */
    var note;
    var nb = r.rel > 0 ? best + 1 : best - 1;
    var closeWord = C.compression ? 'a locked-in hold' : (BOTTOM ? 'a fitted feel' : 'a closer fit');
    if (r.eff >= bounds[bounds.length - 1] + 7) note = C.sizes[N - 1] + ' is our largest size. Expect ' + (C.compression ? 'a firm, second-skin hold.' : 'a closer fit than usual.');
    else if (r.eff < bounds[0] - 7) note = C.sizes[0] + ' is our smallest size. Expect ' + (C.compression ? 'a lighter hold.' : 'a little extra room.');
    else if (!BOTTOM && r.hIdx >= best + 2 && best < N - 1) note = 'Tall for your build. ' + C.sizes[best] + ' fits your chest. Go ' + C.sizes[best + 1] + ' if you want more length.';
    else if (Math.abs(r.rel) > 0.7 && nb >= 0 && nb < N) {
      var tight = Math.min(best, nb), loose = Math.max(best, nb);
      note = 'You sit between ' + C.sizes[tight] + ' and ' + C.sizes[loose] + '. ' + C.sizes[tight] + ' for ' + closeWord + ', ' + C.sizes[loose] + ' for more room.';
    }
    else note = (C.runsSmall ? 'Your size for this cut. ' : 'True to size for your build. ') + 'Go ' + C.sizes[best] + ' and get to work.';
    if (C.runsSmall) note = 'These run a size small, so we have already sized you up. ' + note;
    $('[data-note]').textContent = note;
    var hh = fmtH(S.h), ww = fmtW(S.w);
    $('[data-recap]').textContent = 'Based on ' + hh.n + hh.u + ' · ' + ww.n + ww.u + ' · ' + C.prefs[S.pref].t;
    renderProduct();
    renderFoot();
  }
  function countTo(el, to, animate){
    var from = animate ? 0 : (parseInt(el.getAttribute('data-v'), 10) || 0);
    el.setAttribute('data-v', to);
    var t0 = null, dur = animate ? 1000 : 400;
    cancelAnimationFrame(el.__raf);
    function f(t){
      if (!t0) t0 = t;
      var p = Math.min(1, (t - t0) / dur);
      var e = 1 - Math.pow(1 - p, 3);
      el.textContent = Math.round(from + (to - from) * e) + '% match';
      if (p < 1) el.__raf = requestAnimationFrame(f);
    }
    el.__raf = requestAnimationFrame(f);
  }
  function setHtml(el, html){ if (el.__html !== html) { el.__html = html; el.innerHTML = html; } }
  function renderFoot(){
    var next = $('[data-next]'), back = $('[data-back]'), alt = $('[data-select]');
    back.hidden = step === 0;
    if (step < 2) { setHtml(next, 'Next ' + IC.arrow); next.disabled = false; alt.hidden = true; }
    else if (step === 2) { setHtml(next, 'Get my size ' + IC.arrow); next.disabled = false; alt.hidden = true; }
    else {
      var sz = C.sizes[viewIdx];
      var v = variantFor(sz);
      var col = currentColor();
      if (offerMode()) {
        setHtml(next, 'Use size ' + sz + ' ' + IC.arrow);
        next.disabled = false;
        alt.hidden = true;
      } else if (v && !v.available) {
        setHtml(next, escapeHtml(sz + (col ? ' sold out in ' + col : ' sold out')));
        next.disabled = true;
        alt.hidden = true;
      } else {
        setHtml(next, 'Add ' + sz + ' to cart' + (v && v.price ? ' · ' + escapeHtml(v.price) : ''));
        next.disabled = false;
        alt.hidden = false;
        setHtml(alt, 'Just select ' + sz);
      }
    }
  }
  function renderProgress(){
    var bars = $$('.fu-sf__progress span');
    bars.forEach(function(b, i){ b.classList.toggle('is-on', i <= Math.min(step, 2)); });
    var showProg = step < 3;
    $('.fu-sf__progress').style.display = showProg ? '' : 'none';
    $('[data-count]').style.display = showProg ? '' : 'none';
    $('[data-count]').textContent = 'Step ' + (step + 1) + ' of 3';
  }
  function go(n, back){
    var prev = step;
    step = n;
    $$('[data-step]').forEach(function(s){
      var on = +s.getAttribute('data-step') === n;
      s.hidden = !on;
      if (on) { s.classList.toggle('is-back', !!back); s.style.animation = 'none'; s.offsetHeight; s.style.animation = ''; }
    });
    renderProgress();
    if (n === 0) { renderDial('h'); renderDial('w'); renderFigure(); renderEstimate(); }
    if (n === 1 || n === 2) renderShape();
    if (n === 3) {
      if (prev !== 3) viewIdx = calc(S, true).idx;
      renderResult(prev !== 3);
    }
    renderProduct();
    renderFoot();
    $('.fu-sf__body').scrollTop = 0;
  }

  /* ---------- dials ---------- */
  function stepOf(k){ return k === 'h' ? (S.hu === 'cm' ? 1 : 2.54) : (S.wu === 'kg' ? 1 : 0.45359); }
  function setVal(k, v, snap){
    var r = RANGE[k];
    var st = stepOf(k);
    if (snap !== false) v = Math.round(v / st) * st;
    v = Math.max(r[0], Math.min(r[1], v));
    if (Math.abs(v - S[k]) < 1e-6) return;
    S[k] = v;
    renderDial(k);
    renderFigure();
    renderEstimate();
  }
  function bindDial(k){
    var dial = $('[data-dial="' + k + '"]');
    var dragging = false;
    function fromX(x){
      var rect = dial.getBoundingClientRect();
      var p = Math.max(0, Math.min(1, (x - rect.left) / rect.width));
      setVal(k, RANGE[k][0] + p * (RANGE[k][1] - RANGE[k][0]));
    }
    dial.addEventListener('pointerdown', function(e){
      dragging = true;
      dial.classList.add('is-drag');
      try { dial.setPointerCapture(e.pointerId); } catch (er) {}
      fromX(e.clientX);
      e.preventDefault();
    });
    dial.addEventListener('pointermove', function(e){ if (dragging) fromX(e.clientX); });
    function end(){ dragging = false; dial.classList.remove('is-drag'); }
    dial.addEventListener('pointerup', end);
    dial.addEventListener('pointercancel', end);
    dial.addEventListener('keydown', function(e){
      var st = stepOf(k), d = 0;
      if (e.key === 'ArrowRight' || e.key === 'ArrowUp') d = st;
      else if (e.key === 'ArrowLeft' || e.key === 'ArrowDown') d = -st;
      else if (e.key === 'PageUp') d = st * 10;
      else if (e.key === 'PageDown') d = -st * 10;
      if (d) { e.preventDefault(); setVal(k, S[k] + d); }
    });
  }
  bindDial('h');
  bindDial('w');
  $$('[data-inc]').forEach(function(b){
    var k = b.getAttribute('data-inc'), dir = +b.getAttribute('data-dir');
    var t1, t2;
    function stop(){ clearTimeout(t1); clearInterval(t2); }
    b.addEventListener('pointerdown', function(e){
      e.preventDefault();
      setVal(k, S[k] + dir * stepOf(k));
      t1 = setTimeout(function(){ t2 = setInterval(function(){ setVal(k, S[k] + dir * stepOf(k)); }, 55); }, 380);
    });
    ['pointerup', 'pointerleave', 'pointercancel'].forEach(function(ev){ b.addEventListener(ev, stop); });
    b.addEventListener('keydown', function(e){ if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); setVal(k, S[k] + dir * stepOf(k)); } });
  });
  $$('[data-unit]').forEach(function(b){
    b.addEventListener('click', function(){
      var k = b.getAttribute('data-unit'), u = b.getAttribute('data-u');
      if (k === 'h') S.hu = u; else S.wu = u;
      renderDial(k);
    });
  });

  /* ---------- choices ---------- */
  root.addEventListener('click', function(e){
    var t = e.target.closest ? e.target : null;
    if (!t) return;
    var sh = t.closest('[data-shape]');
    if (sh) { S[sh.getAttribute('data-shape')] = +sh.getAttribute('data-val'); renderShape(); return; }
    var pf = t.closest('[data-pref]');
    if (pf) { S.pref = +pf.getAttribute('data-pref'); renderShape(); return; }
    var sz = t.closest('[data-size]');
    if (sz) { viewIdx = +sz.getAttribute('data-size'); renderResult(false); return; }
    if (t.closest('[data-close]')) { close(); return; }
    if (t.closest('[data-back]')) { go(Math.max(0, step - 1), true); return; }
    if (t.closest('[data-redo]')) { S[DK] = false; go(0, true); return; }
    if (t.closest('[data-select]')) { finish(false); return; }
    if (t.closest('[data-next]')) {
      if (step < 2) go(step + 1);
      else if (step === 2) {
        S[DK] = true;
        save();
        go(3);
        var r = calc(S, true);
        track('fu_size_finder_complete', { product: P.handle, size: C.sizes[r.idx], match: r.pct });
        refreshTrigger();
      }
      else finish(true);
    }
  });

  function finish(andAdd){
    var sz = C.sizes[viewIdx];
    var v = variantFor(sz);
    if (offerMode()) {
      setOfferSize(sz, false);
      track('fu_size_finder_select', { product: P.handle, size: sz, offer: true });
      close();
      var o = offerEl(), cta = o && (o.querySelector('.fuo-cta') || o);
      if (cta) setTimeout(function(){ cta.scrollIntoView({ behavior: 'smooth', block: 'center' }); }, 350);
      return;
    }
    selectSize(sz);
    track(andAdd ? 'fu_size_finder_add' : 'fu_size_finder_select', { product: P.handle, size: sz });
    close();
    if (andAdd && v) setTimeout(function(){ addToCart(v); }, 120);
  }

  /* ---------- open / close ---------- */
  var prevOverflow = '';
  function open(){
    opener = document.activeElement;
    if (!root.parentNode) document.body.appendChild(root);
    root.hidden = false;
    if (canTop) { try { if (root.matches(':popover-open')) root.hidePopover(); root.showPopover(); } catch (e) {} }
    prevOverflow = document.documentElement.style.overflow;
    document.documentElement.style.overflow = 'hidden';
    go(S[DK] ? 3 : ((S.dTop || S.dBot) ? 1 : 0));
    requestAnimationFrame(function(){
      requestAnimationFrame(function(){
        root.classList.add('is-open');
        renderFigure();
        if (step === 3) renderResult(true);
        $('.fu-sf__panel').focus({ preventScroll: true });
      });
    });
    track('fu_size_finder_open', { product: P.handle });
  }
  function close(){
    if (root.hidden) return;
    save();
    root.classList.remove('is-open');
    var panel = $('.fu-sf__panel');
    panel.style.transform = '';
    document.documentElement.style.overflow = prevOverflow;
    setTimeout(function(){
      if (root.classList.contains('is-open')) return;
      root.hidden = true;
      if (canTop) { try { root.hidePopover(); } catch (e) {} }
    }, 480);
    if (opener && opener.focus) try { opener.focus({ preventScroll: true }); } catch (e) {}
  }
  document.addEventListener('keydown', function(e){ if (e.key === 'Escape' && !root.hidden) close(); });

  /* swipe the sheet down to close (phones) */
  (function(){
    var startY = null, dy = 0, panel = $('.fu-sf__panel');
    function down(e){
      if (window.innerWidth > 767) return;
      if (e.target.closest('button')) return;
      startY = e.clientY; dy = 0;
      root.classList.add('is-dragging');
      try { e.currentTarget.setPointerCapture(e.pointerId); } catch (er) {}
    }
    function move(e){
      if (startY === null) return;
      dy = Math.max(0, e.clientY - startY);
      panel.style.transform = 'translate3d(0,' + dy + 'px,0)';
    }
    function up(){
      if (startY === null) return;
      startY = null;
      root.classList.remove('is-dragging');
      if (dy > 110) close(); else panel.style.transform = '';
    }
    ['.fu-sf__grab', '.fu-sf__head'].forEach(function(sel){
      var el = $(sel);
      el.addEventListener('pointerdown', down);
      el.addEventListener('pointermove', move);
      el.addEventListener('pointerup', up);
      el.addEventListener('pointercancel', up);
    });
  })();

  /* ---------- trigger on the product page ---------- */
  function triggerHtml(){
    if (S[DK]) {
      var r = calc(S, true);
      return '<span class="fu-sf-trigger__icon">' + C.sizes[r.idx] + '</span><span class="fu-sf-trigger__text"><span class="fu-sf-trigger__title">Your size: ' + C.sizes[r.idx] + '</span><span class="fu-sf-trigger__sub">' + r.pct + '% match · See how it fits</span></span>' + IC.arrow.replace('<svg', '<svg class="fu-sf-trigger__arrow"');
    }
    return '<span class="fu-sf-trigger__icon">' + IC.tape + '</span><span class="fu-sf-trigger__text"><span class="fu-sf-trigger__title">Find your size</span><span class="fu-sf-trigger__sub">30 sec</span></span>' + IC.arrow.replace('<svg', '<svg class="fu-sf-trigger__arrow"');
  }
  function markRecommended(){
    var fs = sizeFieldset();
    if (!fs) return;
    var rec = S[DK] ? C.sizes[calc(S, true).idx] : null;
    fs.querySelectorAll('input[type="radio"]').forEach(function(inp){
      var lab = fs.querySelector('label[for="' + inp.id + '"]');
      if (lab) lab.classList.toggle('fu-sf-rec', inp.value === rec);
    });
  }
  function refreshTrigger(){
    document.querySelectorAll('.fu-sf-trigger').forEach(function(b){
      b.classList.toggle('is-known', !!S[DK]);
      b.innerHTML = triggerHtml();
    });
    markRecommended();
  }
  function makeTrigger(){
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'fu-sf-trigger' + (S[DK] ? ' is-known' : '');
    b.setAttribute('aria-haspopup', 'dialog');
    b.innerHTML = triggerHtml();
    b.addEventListener('click', open);
    return b;
  }
  function mountTrigger(){
    var o = document.querySelector('.fuo');
    var fs = sizeFieldset();
    /* bundle pages: one link only, in the offer header next to "Size chart" */
    if (o) {
      fs && fs.querySelectorAll('.fu-sf-trigger').forEach(function(t){ t.remove(); });
      var sc = o.querySelector('.fuo-sc');
      if (sc && !o.querySelector('.fu-sf-trigger')) {
        var ob = makeTrigger();
        ob.classList.add('fu-sf-trigger--offer');
        var wrap = document.createElement('span');
        wrap.className = 'fu-sf-headlinks';
        sc.parentNode.insertBefore(wrap, sc);
        wrap.appendChild(ob);
        wrap.appendChild(sc);
        var cs = getComputedStyle(sc);
        ob.style.fontSize = cs.fontSize;
        ob.style.fontWeight = cs.fontWeight;
        ob.style.lineHeight = cs.lineHeight;
        ob.style.color = cs.color;
      }
    } else if (fs && !fs.querySelector('.fu-sf-trigger')) {
      var b = makeTrigger();
      var list = fs.querySelector('ul.swatches');
      if (list && list.nextSibling) fs.insertBefore(b, list.nextSibling); else fs.appendChild(b);
    }
    markRecommended();
  }

  /* returning shopper: pre-select their size if the URL didn't ask for a variant */
  function preselect(){
    if (!S[DK] || /[?&]variant=/.test(location.search)) return;
    var sz = C.sizes[calc(S, true).idx];
    if (offerMode()) { setOfferSize(sz, true); return; }
    var v = variantFor(sz);
    if (v && v.available) selectSize(sz);
  }

  function init(){
    mountTrigger();
    preselect();
    var vs = mainPicker();
    var host = vs && vs.parentNode;
    if (host && window.MutationObserver) {
      new MutationObserver(function(muts){
        /* ignore changes we make ourselves (drawer + trigger), or this would loop */
        var outside = muts.some(function(m){
          var t = m.target;
          return !(root.contains(t) || (t.closest && t.closest('.fu-sf-trigger')));
        });
        if (!outside) return;
        mountTrigger();
        if (!root.hidden && step === 3) { renderProduct(); renderFoot(); }
      }).observe(host, { childList: true, subtree: true });
    }
    document.addEventListener('change', function(e){
      if (e.target && e.target.closest && e.target.closest('variant-selects') && !root.hidden) { renderProduct(); if (step === 3) renderResult(false); }
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  window.addEventListener('load', function(){ mountTrigger(); });
  setTimeout(mountTrigger, 1200);
  document.addEventListener('shopify:section:load', mountTrigger);
  window.FuSizeFinder = { open: open, close: close };
})();
